import Widget from 'models/dashboard/widget'

Widget.TrendingTopicsOnAgentClipsWidget = Widget.extend({
});

export default Widget.TrendingTopicsOnAgentClipsWidget;

